import { DOCUMENT, Inject, Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";

export type ThemePreference = "light" | "dark" | "system";

export const THEME_STORAGE_KEY = "fo-theme";

@Injectable()
export class ThemeService {
    private readonly storageKey = THEME_STORAGE_KEY;
    private readonly replaySubject: BehaviorSubject<ThemePreference>;

    constructor(@Inject(DOCUMENT) private document: Document) {
        this.replaySubject = new BehaviorSubject<ThemePreference>(
            this.readStoredPreference(),
        );
        this.applyPreference(this.replaySubject.value);
    }

    public getPreference(): ThemePreference {
        return this.replaySubject.value;
    }

    public change(): Observable<ThemePreference> {
        return this.replaySubject.asObservable();
    }

    public setPreference(preference: ThemePreference): void {
        try {
            localStorage.setItem(this.storageKey, preference);
        } catch (err) {}
        this.applyPreference(preference);
        this.replaySubject.next(preference);
    }

    private readStoredPreference(): ThemePreference {
        try {
            const stored = localStorage.getItem(this.storageKey);
            if (stored === "light" || stored === "dark" || stored === "system") {
                return stored;
            }
        } catch (err) {}
        return "light";
    }

    private applyPreference(preference: ThemePreference): void {
        const root = this.document.documentElement;
        if (preference === "system") {
            root.removeAttribute("data-theme");
            return;
        }
        root.setAttribute("data-theme", preference);
    }
}
